export default "__VITE_PUBLIC_ASSET__5f3b0a36__"